import { AppDispatch, RootState } from "../store";
import { workspaceActions, WorkspaceTab } from "../slices/workspace";

export const openTab =
  (tabData: WorkspaceTab) =>
  (dispatch: AppDispatch, getState: () => RootState): void => {
    const { tabs } = getState().workspace;
    const existingTab = tabs.find((tab) => tab.id === tabData.id);

    if (!existingTab) {
      const newTabs = [...tabs, tabData];
      dispatch(workspaceActions.setTabs(newTabs));
    }
    dispatch(workspaceActions.setActiveTab(tabData.id));
  };

export const closeTab =
  (tabId: string) =>
  (dispatch: AppDispatch, getState: () => RootState): void => {
    const { tabs, activeTabId } = getState().workspace;
    const index = tabs.findIndex((tab) => tab.id === tabId);

    if (index !== -1) {
      const newTabs = [...tabs];
      newTabs.splice(index, 1);

      if (activeTabId === tabId) {
        const nextTab = newTabs[index] || newTabs[index - 1];
        dispatch(workspaceActions.setActiveTab(nextTab ? nextTab.id : null));
      }
      dispatch(workspaceActions.setTabs(newTabs));
    }
  };

export const focusTab =
  (tabId: string) =>
  (dispatch: AppDispatch, getState: () => RootState): void => {
    const { activeTabId } = getState().workspace;
    if (activeTabId !== tabId) {
      dispatch(workspaceActions.setActiveTab(tabId));
    }
  };
